import { createSlice } from '@reduxjs/toolkit';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
    DUPLICATE,
    DUPLICATE_FAILURE,
    DUPLICATE_SUCCESS,
    FETCH_ITEM_DETAIL,
    FETCH_ITEM_DETAIL_FAILURE,
    FETCH_ITEM_DETAIL_SUCCESS,
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
    INITIALIZE_FORM,
    OPEN_PRODUCT_FORM,
    RESET,
    RESET_FORM,
    SAVE,
    SAVE_FAILURE,
    SAVE_SUCCESS,
    SET_ENABLED_EDITION,
    SET_IS_NEW_RECORD,
    UPDATE_ITEMS_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    bulkUpdateItems: { errors: null, isFetching: false },
    duplicateProduct: { errors: null, isDuplicating: false },
    filters: { orderBy: '', page: 1, searchStr: '', sortBy: '' },
    initialValues: {
        alto: '',
        ancho: '',
        baseproduct_ptr: null,
        brand: null,
        code: null,
        cost: null,
        created_at: null,
        datasheet_archive: null,
        datasheet_name: '',
        default_margin: null,
        description: null,
        family: null,
        id: null,
        image_thumbnail: null,
        imp: '',
        is_active: false,
        isc: '',
        max_dc: '',
        max_p: '',
        module_e: '',
        name: null,
        noct: '',
        num_cells: '',
        peso: '',
        product_type: null,
        profundo: '',
        tk_isc: '',
        tk_pmax: '',
        tk_voc: '',
        type: null,
        updated_at: null,
        vmp: '',
        voc: '',
    },
    isEnabledEdition: true,
    isNewRecord: false,
    isOpenProductForm: false,
    itemDetail: { data: null, errors: [], isFetching: false },
    items: {
        data: { data: [], paginaton: {} },
        error: null,
        isFetching: false,
    },
    productStatus: { data: {}, errors: null, isSaving: false },
    save: { data: {}, errors: null, isSaving: false },
};

const slice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [BULK_UPDATE_ITEMS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: [],
                isSaving: true,
            };
        },
        [BULK_UPDATE_ITEMS_FAILURE]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: action.payload,
                isSaving: false,
            };
        },
        [BULK_UPDATE_ITEMS_SUCCESS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                isSaving: false,
            };
        },
        [DUPLICATE]: (state) => {
            state.duplicateProduct = {
                ...state.duplicateProduct,
                errors: [],
                isDuplicating: true,
            };
        },
        [DUPLICATE_FAILURE]: (state, action) => {
            state.duplicateProduct = {
                ...state.duplicateProduct,
                errors: action.payload,
                isDuplicating: false,
            };
        },
        [DUPLICATE_SUCCESS]: (state) => {
            state.duplicateProduct = {
                ...state.duplicateProduct,
                isDuplicating: false,
            };
        },
        [FETCH_ITEMS]: (state) => {
            state.items = {
                ...state.items,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ITEMS_FAILURE]: (state, action) => {
            state.items = {
                ...state.items,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEMS_SUCCESS]: (state, action) => {
            state.items = {
                ...state.items,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEM_DETAIL]: (state) => {
            state.itemDetail = {
                ...state.itemDetail,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ITEM_DETAIL_FAILURE]: (state, action) => {
            state.itemDetail = {
                ...state.itemDetail,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEM_DETAIL_SUCCESS]: (state, action) => {
            state.itemDetail = {
                ...state.itemDetail,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [OPEN_PRODUCT_FORM]: (state, action) => {
            state.isOpenProductForm = action.payload;
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
        },
        [SAVE]: (state) => {
            state.save = { ...state.save, errors: [], isSaving: true };
        },
        [SAVE_FAILURE]: (state, action) => {
            state.save = {
                ...state.save,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_SUCCESS]: (state) => {
            state.save = {
                ...state.save,
                isSaving: false,
            };
        },
        [SET_ENABLED_EDITION]: (state, action) => {
            state.isEnabledEdition = action.payload;
        },
        [SET_IS_NEW_RECORD]: (state, action) => {
            state.isNewRecord = action.payload;
        },
        [UPDATE_ITEMS_SUCCESS]: (state, action) => {
            state.items.data.data = action.payload;
        },
    },
});

export const actions = slice.actions;

export default slice.reducer;
